import { restClient } from '@/Core'

/** Тіло завершення: витрачений час у хвилинах — опційне, ≥0 (SPEC-003 §5.5). */
export interface CompleteTaskPayload {
    timeSpentInMinutes?: number
}

/**
 * Перехід задачі у «Завершене» (SPEC-003 §5.5, N8, `TASK_COMPLETE`).
 * `POST /services/tasks/{uuid}/complete` з тілом `{ timeSpentInMinutes }`.
 * Перенос легасі `Ship/Tasks/statusApiActions.js:handleCompletedAction`.
 */
export const CompleteTaskTask = async (uuid: string, payload?: CompleteTaskPayload): Promise<void> => {
    await restClient.post(`/services/tasks/${uuid}/complete`, { json: payload ?? {} })
}
